
const m = window.require("discourse/models/composer");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
